import TrackDashboard from '../components/modules/track/index';
import Trips from '../components/modules/track/list';
import Rejections from '../components/modules/track/reject';
import TrackDetails from '../components/modules/track/TrackDetails';
import OpenLinkTrackDetails from '../components/modules/track/OpenLink';
import ConsigneeTrackLink from '../components/modules/track/ConsigneeTrackLink';
import MapView from '../components/modules/track/MapView';

const dashboard = [
  {
    path: '/trackDashboard',
    name: 'TrackDashboard',
    component: TrackDashboard,
    meta: {
      title: 'Track Dashboard',
      permission: 'view_track_dashboard',
    },
  },
  {
    path: '/track',
    name: 'Trips',
    component: Trips,
    meta: {
      title: 'Tracking',
      permission: 'view_trips',
    },
  },
  {
    path: '/rejected',
    name: 'Rejections',
    component: Rejections,
    meta: {
      title: 'Rejections',
      permission: 'view_rejections',
    },
  },
  {
    path: '/track/details',
    name: 'TrackDetails',
    component: TrackDetails,
    meta: {
      title: 'Tracking',
    },
  },
  {
    path: '/ol-track/details',
    name: 'OpenLinkTrackDetails',
    component: OpenLinkTrackDetails,
    meta: {
      title: 'Tracking',
      titleOnly: true,
    },
  },
  {
    path: '/track-link/:orderNo',
    name: 'ConsigneeTrackLink',
    component: ConsigneeTrackLink,
    meta: {
      title: 'Tracking',
      titleOnly: true,
    },
  },
  {
    path: '/mapView',
    name: 'Map View',
    component: MapView,
    meta: {
      title: 'Map View',
      permission: 'view_map',
    },
  },
];

export default dashboard;
